import React from "react";
import {
  userexperience,
  internationalclients,
  getSkillData,
} from "./getconstdata";

const getskillImg = (id) => {
  const index = getSkillData.findIndex((s) => s.id === id);
  return getSkillData[index];
};

const geteLabel = (id) => {
  const index = userexperience.findIndex((l) => l.value === id);
  return userexperience[index].label;
};

const getsLabel = (id) => {
  const index = internationalclients.findIndex((l) => l.value === id);
  return internationalclients[index].label;
};

const Candidatedetails = ({ getData }) => {
  return (
    <>
      <section className="candidateDetailsSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>Confirm your details</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="details">
                <p className="head">You Applied as a</p>
                {getData.userskill.includes(10) ? (
                  <p className="sub">{getData.getAnotherSkill}</p>
                ) : (
                  <div className="row">
                    {getData.userskill.map((i) => (
                      <div
                        className="col-lg-2 col-md-2 col-sm-3 col-4 techImg mb-3"
                        key={getskillImg(i).images}
                      >
                        <div className="images">
                          <img
                            src={getskillImg(i).images}
                            className="img-fluid"
                            alt="Hire Xamarin Developer"
                          />
                          <span>{getskillImg(i).name}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div className="row">
                <div className="col-lg-4 col-md-6 details">
                  <p className="head">Your Full Name</p>
                  <p className="sub">
                    {getData.userinfo.name ? getData.userinfo.name : null}
                  </p>
                </div>
                {getData.userinfo.number ? (
                  <div className="col-lg-4 col-md-6 details">
                    <p className="head">Your Phone Number</p>
                    <p className="sub"> +{getData.userinfo.number} </p>
                  </div>
                ) : null}
                <div className="col-lg-4 col-md-6 details">
                  <p className="head">Your Email ID</p>
                  <p className="sub">
                    {getData.userinfo.email ? getData.userinfo.email : null}
                  </p>
                </div>
                <div className="col-lg-4 col-md-6 details">
                  <p className="head">Your Experience</p>
                  <p className="sub">
                    {getData.userexperience
                      ? geteLabel(getData.userexperience)
                      : null}
                  </p>
                </div>
                <div className="col-lg-4 col-md-6 details">
                  <p className="head">Work with International Clients</p>
                  <p className="sub">
                    {getData.internationalclients
                      ? getsLabel(getData.internationalclients)
                      : null}
                  </p>
                </div>
                <div className="col-lg-4 col-md-6 details">
                  <p className="head">Your Resume</p>
                  <p className="sub">
                    {getData.uploadcv.name
                      ? getData.uploadcv.name
                      : "No file chosen..."}
                  </p>
                  {getData.nightShift ? (
                    <p className="text-success mt-3">
                      You are Interested In Getting 12% Higher Pay In Night
                      Shift
                    </p>
                  ) : null}
                </div>
                <div className="col-lg-4 col-md-6 details">
                  <p className="head">Your Current Compensation Range</p>
                  <p className="sub">
                    {getData.compensation ? getData.compensation : null}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Candidatedetails;
